import type { ClausensWordClass } from "../types";

const wordClassMap: Record<ClausensWordClass, string> = {
  article: "artikel",
  abbreviation: "forkortelse",
  affix: "affiks",
  numeral: "numerale",
  person: "person",
  pronoun: "pronomen",
  conjunction: "konjuktion",
  interjection: "interjektion",
  preposition: "præposition",
  suffix: "endelse",
  "modal verb": "modalverbum",
  "reflective verb": "refleksivt verbum",
  adjective: "adjektiv",
  adverb: "adverbium",
  noun: "substantiv",
  "no article": "",
  "transitive verb": "transitivt verbum",
  "intransitive verb": "intransitive verbum",
  verb: "verbum"
};

export function mapWordClass(wordClass: string): string {
  const mapped = wordClassMap[wordClass as ClausensWordClass];

  if (!mapped) {
    return wordClass;
  }

  return mapped;
}
